import { VideoCreatorErrorCode } from '../../types/store';

export function getBabelKeyFromErrorCode(
  code: VideoCreatorErrorCode
): string | null {
  switch (code) {
    case VideoCreatorErrorCode.ILLEGAL_PROMPT:
      return 'studio.videoCreator.errorMessage.illegalPrompt';
    case VideoCreatorErrorCode.OUT_OF_SPACE:
      return 'studio.videoCreator.errorMessage.outOfSpace';
    case VideoCreatorErrorCode.OUT_OF_FILE_QUOTA:
      return 'studio.videoCreator.errorMessage.outOfFileQuota';
    case VideoCreatorErrorCode.TOS_VIOLATION:
      return 'studio.videoCreator.errorMessage.tosViolation';
    case VideoCreatorErrorCode.TOO_FAST:
      return 'studio.videoCreator.errorMessage.tooFast';
    default:
      return null;
  }
}
